import { render, staticRenderFns } from "./CouponLog.vue?vue&type=template&id=555334b4&scoped=true&"
import script from "./CouponLog.vue?vue&type=script&lang=js&"
export * from "./CouponLog.vue?vue&type=script&lang=js&"
import style0 from "./CouponLog.vue?vue&type=style&index=0&id=555334b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555334b4",
  null
  
)

export default component.exports